'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormContext, useWatch } from 'react-hook-form';
import type { Product, TailoredApiData } from '@libs/common-types';
import { shouldRenderNearbyStoresCta } from '../lib';
import type { MiniPdpForm } from '../types';
export type UseMiniPdpBopisProps = Readonly<{
  product?: Product;
  tailored: TailoredApiData | null;
  isLoading: boolean;
  isError: boolean;
}>;
export function useMiniPdpBopis(t0) {
  const $ = _c(17);
  const {
    product,
    tailored,
    isLoading,
    isError
  } = t0;
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "fulfilmentMethod"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fulfilmentMethod = useWatch(t1);
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: "selectedSku"
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedSku = useWatch(t2);
  const bopis = selectedSku ? tailored?.variants[selectedSku]?.BOPIS : undefined;
  const storeId = bopis?.storeId;
  const storeData = storeId ? tailored?.bopisStoreData?.[storeId] : undefined;
  const availableStock = bopis?.availableStock ?? 0;
  const minimumCaseQty = product?.deliveryMethods.BOPIS.purchaseQuantities?.min ?? 1;
  const t3 = fulfilmentMethod === "bopis" && !isError;
  let t4;
  if ($[4] !== bopis?.altAvailableStock || $[5] !== bopis?.availableStock || $[6] !== fulfilmentMethod || $[7] !== isError || $[8] !== storeId) {
    t4 = !isError && shouldRenderNearbyStoresCta({
      fulfilmentMethod,
      storeId,
      availableStock: bopis?.availableStock,
      altAvailableStock: bopis?.altAvailableStock
    });
    $[4] = bopis?.altAvailableStock;
    $[5] = bopis?.availableStock;
    $[6] = fulfilmentMethod;
    $[7] = isError;
    $[8] = storeId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = storeData?.storeDetails ?? null;
  let t6;
  if ($[10] !== availableStock || $[11] !== isLoading || $[12] !== minimumCaseQty || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = {
      isLoading,
      shouldRender: t3,
      shouldRenderNearbyStoresCTA: t4,
      storeDetails: t5,
      availableStock,
      minimumCaseQty
    };
    $[10] = availableStock;
    $[11] = isLoading;
    $[12] = minimumCaseQty;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}